import { generateBaseQueryKeysList } from '@/queries/utils';

export const HOSPITALS_KEYS = {
  main: 'hospitals',
};

export const hospitalsQueryKeys = generateBaseQueryKeysList(HOSPITALS_KEYS.main);
